import ArrowIcon from 'assets/icons/arrow-down-icon.svg';
import ReferralMobile from 'components/Profile/components/Referral/mobile';
import { PROFILE_TABS_2 } from 'constants';
import useCommonStore from 'hooks/useCommonStore';
import useLang from 'hooks/useLang';
import useQuery from 'hooks/useQuery';
import useTheme from 'hooks/useTheme';
import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import BuildVersionSection from '../../../BuildVersionSection';
import NotificationsMobile from '../../../Notifications/mobile/ver2';
import PersonalDetailsMobile from '../../../PersonalDetails/mobile/ver2';
import SecurityMobile from '../../../Security/mobile/ver2';
import NotifyBadge from '../../NotifyBadge';

const ProfileBodyMobile = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  const { notifications } = useCommonStore();
  const { isHHMTTheme } = useTheme();

  const query = useQuery();
  const tab = query.get('tab');
  const notificationsUnRead = notifications?.filter(({ read }) => !read);

  const [currentTab, setCurrentTab] = useState(-1);

  useEffect(() => {
    if (tab) {
      setCurrentTab(parseInt(tab));
    }
  }, [tab]);

  const profileTabs = isHHMTTheme
    ? PROFILE_TABS_2
    : PROFILE_TABS_2?.slice(0, -1);

  const tabContentReference = {
    0: <PersonalDetailsMobile />,
    1: <SecurityMobile />,
    2: <NotificationsMobile />,
    3: <ReferralMobile />,
  };

  const handleTabOnClick = (path) => {
    navigate(path);
  };

  const renderButtonTabRightIcon = (index, tab) => {
    if (index === 2 && !isEmpty(notificationsUnRead))
      return (
        <TabLabel>
          {t(tab.label)}
          <NotifyBadge />
        </TabLabel>
      );
    return (
      <>
        <TabText>
          <TabLabel>{t(tab.label)}</TabLabel>
          {tab?.desc && <TabDesc>{t(tab.desc)}</TabDesc>}
        </TabText>
        <ArrowImage src={ArrowIcon} width={11.67} height={6.67} />
      </>
    );
  };

  return (
    <ProfileBodyMobileStyled>
      {profileTabs.map((tab, index) => (
        <ButtonTab
          key={tab.label}
          onClick={() => handleTabOnClick(`${tab.path}?tab=${index}`)}
        >
          <TabImage src={tab.iconOutline} width={20} height={20} />
          {renderButtonTabRightIcon(index, tab)}
        </ButtonTab>
      ))}
      {tabContentReference[currentTab]}
      <BuildVersionSection />
    </ProfileBodyMobileStyled>
  );
};

export const ProfileBodyMobileStyled = styled.div`
  position: absolute;
  width: 100%;
  margin-inline: -16px;
  top: 130px;
  background: #fcfcfc;
  padding: 20px 16px;
  border-radius: 20px 20px 0 0;
  height: calc(100% - 150px);
`;

const ButtonTab = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 60px;
  background: #ffffff;
  box-shadow: none;
  border-radius: 100px;
  padding-inline: 10px;
  position: relative;
  margin-bottom: 10px;
`;
const TabText = styled.div`
  display: grid;
`;
const TabLabel = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #0e1012;

  display: flex;
  align-items: center;
  margin: 0;
`;
const TabDesc = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #7a8189;

  display: flex;
  align-items: center;
  margin: 0;
`;

const TabImage = styled.img`
  margin-right: 4px;
`;

const ArrowImage = styled.img`
  padding: 0px;
  transform: rotate(270deg);
  position: absolute;
  right: 10px;
  object-fit: contain;
`;

export default ProfileBodyMobile;
